<template>
  <section
    class="pxp-cta-3 tw-py-16 lg:tw-py-24"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
  >
    <div class="container">
      <div class="tw-grid tw-max-w-xl tw-grid-cols-1 tw-gap-12 xl:tw-max-w-none xl:tw-grid-cols-12 xl:tw-gap-20">
   
        <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-8 max-lg:tw-order-2 xl:tw-col-span-5">
          <h3>{{ vars.titleText }}</h3>
          <div class="tw-flex tw-flex-col tw-gap-5">
            <details v-for="(faq, index) in faqs" :key="index" :open="index === openIndex">
              <summary
                class="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-duration-300"
                @click.prevent="openIndex = openIndex === index ? null : index"
              >
                <h5 class="tw-flex-1 tw-mt-2">
                  {{ faq.title }}
                </h5>

           
                <span class="tw-ml-3 tw-flex-shrink-0">
          
                  <svg
                    v-if="openIndex !== index"
                    width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="tw-duration-300"
                  >
                    <line x1="0.002" y1="12.625" x2="24.002" y2="12.625" stroke="white" stroke-width="2"/>
                    <line x1="12.002" y1="24.625" x2="12.002" y2="0.625" stroke="white" stroke-width="2"/>
                  </svg>

               
                  <svg
                    v-else
                    width="20" height="3" viewBox="0 0 20 3" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="tw-duration-300"
                  >
                    <line x1="0.002" y1="1.875" x2="20.002" y2="1.875" stroke="white" stroke-width="2"/>
                  </svg>
                </span>
              </summary>

              <p class="tw-mt-2 tw-min-h-24">
                {{ faq.description }}
              </p>
            </details>
          </div>
        </div>

 
        <div
          class="tw-order-first tw-w-full tw-self-start tw-object-contain max-lg:tw-order-1 xl:tw-order-none xl:tw-col-span-7"
          :class="{
            'xl:tw-col-start-1 xl:tw-row-start-1': vars.isReversedBool,
          }"
        >
          <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="600" is="div">
            <div v-if="vars.photoImage && !vars.videoUrl">
              <library-image :src="vars.photoImage" :alt="vars.titleText" class="tw-w-full" />
            </div>
          </MotionGroup>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'FAQ',
  mixins: [ComponentMixin],
  data() {
    return {
      openIndex: 0,
    };
  },
  computed: {
    faqs() {
      return this.groupedVariables.faqs;
    },
  },
});
</script>

<style scoped>


details[open] > summary,
details > summary:hover {
  color: var(--c-secondary);
}


details {
  overflow: hidden;
}
details[open] p {
  animation: animateUp 0.5s linear forwards;
}
@keyframes animateUp {
  0% { opacity: 0; }
  100% { opacity: 1; }
}



</style>
